// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3WQQK","FinishedQuiz":"Button_FinishedQuiz__4k0Yc","success":"Button_success__1zTiv","error":"Button_error__25Slc","primary":"Button_primary__2nbQZ"};